package org.example.site_web.components.images


import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import com.varabyte.kobweb.compose.dom.GenericTag
import com.varabyte.kobweb.compose.dom.svg.*
import com.varabyte.kobweb.compose.dom.svg.Rect
import com.varabyte.kobweb.compose.style.KobwebComposeStyleSheet.attr
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.IconRenderStyle
import com.varabyte.kobweb.silk.theme.shapes.Path
import com.varabyte.kobweb.silk.theme.shapes.Rect
import kotlinx.coroutines.delay
import org.example.site_web.aiPalette
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.unaryMinus
import org.jetbrains.compose.web.dom.AttrBuilderContext
import org.jetbrains.compose.web.dom.ContentBuilder
import org.jetbrains.compose.web.dom.ElementScope
import org.w3c.css.masking.SVGMaskElement
import org.w3c.dom.svg.SVGElement


@Composable
fun ThreeArrowsSvg(modifier: Modifier = Modifier, frame: Double) {
    Svg(
        attrs = modifier.toAttrs {
            viewBox(0, 0, 64, 64)
        }
    )
    {
        val offset = 100 - frame.toInt()


        val argradient = SvgId("argradient")

//        Defs() {
//            LinearGradient(id = argradient,
//                Modifier.toAttrs{
//                    attr("gradientTransform","rotate(90)")
//                }) {
//                Stop((0 ).percent, aiPalette.mainPalette.primary)
//                Stop((100 ).percent, aiPalette.mainPalette.darkest)
//            }
//
//            RadialGradient(id = agradient) {
//                Stop((0).percent, aiPalette.mainPalette.primary)
//                //Stop((100-offset.value).percent, aiPalette.mainPalette.primary)
//                Stop((100 - offset).percent, aiPalette.mainPalette.darkest)
//                Stop((100).percent, aiPalette.mainPalette.darkest)
//            }
//
//
//        }
//        Mask(Modifier.toAttrs {
//            id("tamask")
//        }) {
//            Line {
//                x1(32)
//                y1(60)
//                x2(32)
//                y2(6)
//                fillRule(SVGFillRule.EvenOdd)
//                stroke(Colors.White)
//                strokeWidth(strokeW)
//                strokeLineCap(SVGStrokeLineCap.Round)
//            }
//            Line {
//                x1(32)
//                y1(6)
//                x2(22)
//                y2(16)
//                fillRule(SVGFillRule.EvenOdd)
//                stroke(Colors.White)
//                strokeWidth(strokeW)
//                strokeLineCap(SVGStrokeLineCap.Round)
//            }
//            Line {
//                x1(32)
//                y1(6)
//                x2(42)
//                y2(16)
//                fillRule(SVGFillRule.EvenOdd)
//                stroke(Colors.White)
//                strokeWidth(strokeW)
//                strokeLineCap(SVGStrokeLineCap.Round)
//            }
//            //******************************************
//            Path {
//                d("M 42 32 A 10 10 0 0 0 32 42")
//                //fillRule(SVGFillRule.EvenOdd)
//                stroke(Colors.White)
//                strokeWidth(strokeW)
//                strokeLineCap(SVGStrokeLineCap.Round)
//            }
//
//            Line {
//                x1(42)
//                y1(32)
//                x2(60)
//                y2(32)
//                fillRule(SVGFillRule.EvenOdd)
//                stroke(Colors.White)
//                strokeWidth(strokeW)
//                strokeLineCap(SVGStrokeLineCap.Round)
//            }
//            Line {
//                x1(60)
//                y1(32)
//                x2(50)
//                y2(22)
//                fillRule(SVGFillRule.EvenOdd)
//                stroke(Colors.White)
//                strokeWidth(strokeW)
//                strokeLineCap(SVGStrokeLineCap.Round)
//            }
//            Line {
//                x1(60)
//                y1(32)
//                x2(50)
//                y2(42)
//                fillRule(SVGFillRule.EvenOdd)
//                stroke(Colors.White)
//                strokeWidth(strokeW)
//                strokeLineCap(SVGStrokeLineCap.Round)
//            }
//            // }
//            Path {
//                d("M 22 32 A 10 10 0 0 1 32 42")
//                //fillRule(SVGFillRule.EvenOdd)
//                stroke(Colors.White)
//                strokeWidth(strokeW)
//                strokeLineCap(SVGStrokeLineCap.Round)
//            }
//
//            Line {
//                x1(22)
//                y1(32)
//                x2(4)
//                y2(32)
//                fillRule(SVGFillRule.EvenOdd)
//                stroke(Colors.White)
//                strokeLineCap(SVGStrokeLineCap.Round)
//
//                strokeWidth(strokeW)
//            }
//
//            Line {
//                x1(4)
//                y1(32)
//                x2(14)
//                y2(22)
//                fillRule(SVGFillRule.EvenOdd)
//                stroke(Colors.White)
//                strokeWidth(strokeW)
//                strokeLineCap(SVGStrokeLineCap.Round)
//            }
//            Line {
//                x1(4)
//                y1(32)
//                x2(14)
//                y2(42)
//                fillRule(SVGFillRule.EvenOdd)
//                stroke(Colors.White)
//                strokeWidth(strokeW)
//                strokeLineCap(SVGStrokeLineCap.Round)
//            }
//        }



        Rect() {
            x(0)
            y(0)
            width(64)
            height(64)
            fill(argradient)
            attr("mask", "url(#three-arrows-mask)")
        }
    }

}

